// extracted by mini-css-extract-plugin
export default {"todo":"Todo_todo__KiZK5","completed":"Todo_completed__3tKDD","incompleted":"Todo_incompleted__NVmF7","todoIcon":"Todo_todoIcon__WRFkG"};